// assets/footer-accordion.js
document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.footer-block__accordion-toggle');

  toggles.forEach(toggle => {
    toggle.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const isActive = content.classList.contains('active');

      // 收起所有手风琴内容
      document.querySelectorAll('.footer-block__accordion-content').forEach(item => {
        item.classList.remove('active');
      });
      document.querySelectorAll('.footer-block__accordion-toggle').forEach(item => {
        item.classList.remove('active');
      });

      // 展开或收起当前内容
      if (!isActive) {
        content.classList.add('active');
        this.classList.add('active');
      }
    });
  });
});